import { createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';

export default (rootReducer, preloadedState, middleware) =>
    createStore(rootReducer, preloadedState, applyMiddleware(
        ...middleware,
        ...[process.env.REACT_APP_REDUX_DEBUG === 'true' && logger].filter(Boolean)
    ));
